// Init ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

//Main.JS
function openCloseSidebar() {
    var sidebarMenu = $('#sidebar');
    var sidebarShade = $('.sidebar_shade');
    var sidebarShadetext = $('.sidebar_shade span');
    var sidebarImage = $('#sidebar__image');
    var sidebar = $('#menu_sidebar_wrap');
    var sidebarSpans = $('#sidebar__image span');
    var menuItems = $('#sidebar .menu > li').toArray();
    var openMenu = $('#magnetic-area');
    var closeMenu = $('#sidebar__close');
    var menuTimeline = gsap.timeline();

    if (window.matchMedia('(max-width: 991px)').matches) {
        menuTimeline
            .to(sidebar, {duration: 0.3, x: '100%', ease: 'Power3.easeInOut'})
            .to(sidebarMenu, {duration: 0.1, opacity: 1, ease: 'Power3.easeInOut'})
            .staggerFromTo(menuItems, 0.6, {
                opacity: 0,
                x: '-50%'
            }, {
                opacity: 1,
                x: '0%'
            }, .06, '-=.2')
            .pause();
        openMenu.on('click', function () {
            menuTimeline.play();
        });
        closeMenu.on('click', function () {
            menuTimeline.reverse();
        });
    } else {
        //GSAP ANIMATION DESKTOP//
        menuTimeline
            .to(sidebarShade, {duration: 1, width: '100%', ease: 'power3.inOut'}, 0)
            .to(sidebarShadetext, {duration: 0.3, opacity: 1, ease: 'power3.inOut'}, 0.5)
            .to(sidebar, {duration: 1, x: '100%', ease: 'power3.inOut'}, 0.6)
            .to(sidebarSpans, {duration: 0.6, opacity: 1, ease: 'power3.inOut'}, 1.8)
            .fromTo(menuItems, {opacity: 0, x: '-50%'},
                {opacity: 1, x: '0%', stagger: 0.1}, 1.2)
            .pause();

        openMenu.on('click', function () {
            menuTimeline.timeScale(1).play();
        });
        closeMenu.on('click', function () {
            menuTimeline.timeScale(1.5).reverse();
        });
    }
}

function breadcrumbPosition() {
    var breadcrumb = $('#breadcrumb');
    var slideshowWrap = $('.slideshow__wrap');
    var location = $('#location');
    var main = $('main');

    if ((slideshowWrap.length) || (location.length) || ($('.post-template-default').length)) {
    } else {
        breadcrumb.addClass('on_left');
        breadcrumb.addClass('on_top');
    }

    if (!($('body').hasClass('post-template-default')) || !($('body').hasClass('blog'))) {
        if (slideshowWrap.length) {
        } else {
            main.addClass('no_slideshow');
        }
    }

    if (!($('.slideshow__box_wrap').length)) {
        breadcrumb.addClass('on_left');
        slideshowWrap.addClass('no_box');
    }

    if ($('body.page-template-template-location').length) {
        breadcrumb.removeClass('on_left');
    }
}

function fixedHeader() {

    ScrollTrigger.matchMedia({
        // large
        "(min-width: 992px)": function () {
            // setup animations and ScrollTriggers for screens 992px wide or greater...
            // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
            var tlBook = gsap.timeline({
                scrollTrigger: {
                    trigger: 'header', //this is the element that will trigger the animation
                    start: 100, //this string defines the trigger and scroller start
                    scrub: false, //this tells GSAP to link animation progress to scroll progress
                    //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
                    toggleActions: "play none resume reverse",
                    toggleClass: 'enable'
                }
            });
            tlBook.to('a#book_now_desktop', {
                x: 30,
                y: -50,
                height: '100px',
                duration: 0.3,
                ease: 'Power3.easeInOut'
            }, 0);
            tlBook.to('header .header__left a .icon', {
                display: 'none',
                autoAlpha: 0,
                duration: 0.3,
                ease: 'Power3.easeInOut'
            }, 0);
            tlBook.to('#lang_selector', {x: 30, duration: 0.3, ease: 'Bounce.easeInOut'}, 0.3);
            tlBook.to('header', {
                height: '100px',
                boxShadow: '0 -5px 20px rgba(0, 0, 0, 0.5)',
                duration: 0.2,
                ease: 'Power3.easeInOut'
            }, 0);
        },
        // medium
        "(min-width: 768px) and (max-width: 991px)": function () {
            // The ScrollTriggers created inside these functions are segregated and get
            // reverted/killed when the media query doesn't match anymore.
            var tlBook = gsap.timeline({
                scrollTrigger: {
                    trigger: 'header', //this is the element that will trigger the animation
                    start: 100, //this string defines the trigger and scroller start
                    scrub: false, //this tells GSAP to link animation progress to scroll progress
                    //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
                    toggleActions: "play none resume reverse"
                }
            });
            tlBook.to('a#book_now_desktop', {y: -50, duration: 0.2, ease: 'Power3.easeInOut'});
            tlBook.to('header', {
                boxShadow: '0 -5px 20px rgba(0, 0, 0, 0.5)',
                duration: 0.2,
                ease: 'Power3.easeInOut'
            }, 0);
        },

        // small
        "(max-width: 767px)": function () {
            // The ScrollTriggers created inside these functions are segregated and get
            // reverted/killed when the media query doesn't match anymore.
        },

        // all
        "all": function () {
            // ScrollTriggers created here aren't associated with a particular media query,
            // so they persist.
        }

    });
}

function slideshow() {

    if ($('#slideshow').length) {
        // SPLIDE.JS //
        //Initialize SLIDESHOW Splide.JS
        var slideshow = new Splide('#slideshow', {
            type: 'loop',
            arrows: false,
            pauseOnHover: false, // must be false
            pauseOnFocus: false, // must be false
            resetProgress: false,
            lazyLoad: 'nearby',
            autoplay: true,
            interval: 7000,
            pauseOnHover: false,
            video: {
                loop: true,
                mute: false,
                playerOptions: {
                    youtube: {
                        controls: 0,
                        modestbranding: 1,
                        enablejsapi: 1,
                        fs: 0,
                        iv_load_policy: 3,
                        rel: 0,
                        showinfo: 0,
                        ecver: 2,
                    }
                }
            }
        }).mount(window.splide.Extensions);

        //Play/Pause Video

        if (slideshow.length <= 1) {
            slideshow.Components.Autoplay.pause();
            $('#slideshow .splide__pagination').hide();
        }

        var pauseIcon = $('#pause_icon');
        var playIcon = $('#play_icon');

        $('.splide__video').click(() => {
            slideshow.Components.Autoplay.pause();
        });

        $('.slideshow__control').click(() => {
            slideshow.Components.Autoplay.pause();
            slideshow.go(0);
            if ($('#slideshow').hasClass('is-playing')) {
                slideshow.Components.Video.pause(
                    slideshow.Components.Autoplay.play()
                );
                playIcon.show();
                pauseIcon.hide();
            } else {
                slideshow.Components.Video.play();
                playIcon.hide();
                pauseIcon.show();
            }
        });
        //Show/Hide play button
        $('.slideshow__control').addClass('show_control');

        // slideshow.on('moved', function () {
        //     var slideshowActive = $('#slideshow li.is-active');
        //     var playPauseButton = $('.slideshow__control');
        //     slideshow.Components.Autoplay.play();
        //     if (slideshowActive.hasClass('splide__slide--has-video')) {
        //         playPauseButton.addClass('show_control');
        //     } else {
        //         playPauseButton.removeClass('show_control');
        //     }
        //     playIcon.show();
        //     pauseIcon.hide();
        // });
        if (window.matchMedia('(max-width: 991px)').matches) {
            $('.slideshow__wrap #slideshow').css({
                height: $('.slideshow__wrap #slideshow').width() * 0.56
            });
        }
    }
}

function minigallery() {

    if ($('#minigallery_splide').length) {

        var bodyHome = $('body').hasClass('home');
        var bodyDefault = $('body').hasClass('page-template-default');
        var bodyRoom = $('body').hasClass('single-rooms');
        var bodyLocation = $('body').hasClass('page-template-template-location');
        if ((bodyHome === false && bodyDefault === true) || (bodyRoom === true) || (bodyLocation === true)) {
            // SPLIDE.JS //
            //Initialize MINIGALLERY Splide.JS
            var minigallery = new Splide('#minigallery_splide', {
                type: 'loop',
                arrows: true,
                pauseOnHover: false, // must be false
                pauseOnFocus: false, // must be false
                resetProgress: false,
                lazyLoad: 'nearby',
                padding: '15rem',
                gap: '20px',
                pagination: true,
                breakpoints: {
                    1300: {
                        padding: '8rem',
                        pagination: true
                    },
                    991: {
                        padding: '3rem',
                        pagination: true
                    },
                    767: {
                        padding: '3rem',
                        pagination: false
                    }

                },
            }).mount();
        }
    }
}

function slideshowPreviewRooms() {
    if ($('#preview-rooms').length) {
        var bodyHome = $('body').hasClass('home');
        var bodyRoom = $('body').hasClass('single-rooms');

        if ((bodyHome === true) || (bodyRoom === true)) {
            // SPLIDE.JS //
            //Initialize MINIGALLERY Splide.JS
            var slideshowPrevRooms = new Splide('#gallery-rooms', {
                type: 'loop',
                arrows: true,
                perPage: 3,
                pauseOnHover: false, // must be false
                pauseOnFocus: false, // must be false
                resetProgress: false,
                lazyLoad: 'nearby',
                padding: '20px',
                gap: '40px',
                breakpoints: {
                    1200: {
                        perPage: 2,
                    },
                    900: {
                        perPage: 1,
                    },
                },
            }).mount();
        }
    }
}

function slideshowNews() {
    if ($('#preview-news').length) {
        var bodyHome = $('body').hasClass('home');
        if (bodyHome) {
            // SPLIDE.JS //
            //Initialize MINIGALLERY Splide.JS
            var slideshowNews = new Splide('#news_slideshow', {
                type: 'slide',
                arrows: false,
                perPage: 3,
                pagination: false,
                pauseOnHover: false, // must be false
                pauseOnFocus: false, // must be false
                resetProgress: false,
                lazyLoad: 'nearby',
                gap: '20px',
                breakpoints: {
                    1200: {
                        perPage: 2,
                        arrows: true,
                        padding: '5rem',
                        gap: '20px',
                    },
                    900: {
                        perPage: 1,
                        arrows: true,
                        padding: '5rem',
                        gap: '20px',
                    },
                    400: {
                        perPage: 1,
                        arrows: true,
                        padding: '25px',
                        gap: '10px',
                    },
                },
            }).mount();
        }
    }
}

function slideshowOffers() {
    var bodySingleOffer = $('body').hasClass('single-offers');
    var bodySingleRoom = $('body').hasClass('single-rooms');
    if ((bodySingleOffer) || (bodySingleRoom)) {
        // SPLIDE.JS //
        //Initialize OFFERS CAROUSEL Splide.JS
        var slideshowOffers = new Splide('#offers_carousel_splide', {
            type: 'loop',
            arrows: true,
            perPage: 2,
            pagination: true,
            pauseOnHover: false, // must be false
            pauseOnFocus: false, // must be false
            resetProgress: false,
            lazyLoad: 'nearby',
            gap: '90px',
            heightRatio: 0.4,
            padding: 60,
            breakpoints: {
                1200: {
                    heightRatio: 0.5,
                    gap: '60px',
                    padding: 30,
                },
                991: {
                    heightRatio: 0.6,
                    gap: '60px',
                    padding: 30,
                    perPage: 1,
                },
                991: {
                    heightRatio: 1,
                    gap: '60px',
                    padding: 20,
                    perPage: 1,
                },
                767: {
                    heightRatio: 1.2,
                    gap: '60px',
                    padding: 20,
                    perPage: 1,
                }
            },
        }).mount();
    }
}

function slideshowPosts() {
    var bodyBlog = $('body').hasClass('blog');
    if (bodyBlog) {
        // SPLIDE.JS //
        //Initialize OFFERS CAROUSEL Splide.JS
        var slideshowOffers = new Splide('#post-carousel_splide', {
            type: 'loop',
            arrows: true,
            pagination: true,
            // perPage: 1,
            pauseOnHover: false, // must be false
            pauseOnFocus: false, // must be false
            resetProgress: false,
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'center',
            //padding: '20rem',
            gap: '30px',
            breakpoints: {
                /*1300: {
                    padding: '8rem',
                },
                991: {
                    padding: '6rem',
                },*/
                767: {
                    // padding: '1rem',
                    pagination: false,
                    //fixedHeight: 500,
                    gap: '10px',
                }

            },
        }).mount();
    }
}

function animationMainContent() {
    const bodyHome = $('body').hasClass('home');
    const bodyDefault = $('body').hasClass('page-template-default');
    if ((bodyHome && bodyDefault)) {
        let tlMainContent = gsap.timeline({
            scrollTrigger: {
                trigger: '#main_content', //this is the element that will trigger the animation
                start: 'top-=300px center', //this string defines the trigger and scroller start
                end: 'bottom-=100px center', //this string defines the trigger and scroller end
                //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
                scrub: false, //this tells GSAP to link animation progress to scroll progress
                toggleActions: "play pause resume reverse"
            }
        });

        var sloganItems = $('#slogan .item').toArray();

        tlMainContent
            .to('#border_left_right', {scaleY: 1, ease: "Power3.easeInOut"}, 0)
            .to('#border_top_bottom', {scaleX: 1, ease: "Power3.easeInOut"}, 0)
            .staggerTo(sloganItems, 1, {scale: 1, ease: 'Power3.easeInOut'}, 0.16)
    }
}

function animationEatDrink() {
    const bodyHome = $('body').hasClass('home');
    const bodyDefault = $('body').hasClass('page-template-default');
    if ((bodyHome && bodyDefault)) {

        let tlEatDrink = gsap.timeline({
            scrollTrigger: {
                trigger: '#preview-eat_drink', //this is the element that will trigger the animation
                start: 'top-=200px center', //this string defines the trigger and scroller start
                end: 'bottom-=200px center', //this string defines the trigger and scroller end
                scrub: false, //this tells GSAP to link animation progress to scroll progress
                toggleActions: "play pause resume reverse"
            }
        });

        tlEatDrink
            .to('#food .item:nth-child(1)', {duration: 0.3, x: "0px", y: "0px"}, 0)
            .to('#food .item:nth-child(2)', {duration: 0.3, x: "0px", y: "0px"}, 0)
            .to('#food .item:nth-child(3)', {duration: 0.3, x: "0px", y: "0px"}, 0)
            .to('#food .item:nth-child(4)', {duration: 0.3, x: "0px", y: "0px"}, 0)
    }
}

function animationFoodPrev() {
    const bodyHome = $('body').hasClass('home');
    const bodyDefault = $('body').hasClass('page-template-default');
    if ((bodyHome === false && bodyDefault === true)) {

        let tlFoodPrev = gsap.timeline({
            scrollTrigger: {
                trigger: '#features', //this is the element that will trigger the animation
                start: 'top center', //this string defines the trigger and scroller start
                end: 'bottom center', //this string defines the trigger and scroller end
                scrub: false, //this tells GSAP to link animation progress to scroll progress
                toggleActions: "play pause resume reverse"
            }
        });


        tlFoodPrev
            .to('#features__food .item_wrap:nth-child(1) .item', {duration: 0.3, rotate: 0}, 0)
            .to('#features__food .item_wrap:nth-child(2) .item', {duration: 0.3, rotate: 0}, 0)
            .to('#features__food .item_wrap:nth-child(3) .item', {duration: 0.3, rotate: 0}, 0)
            .to('#features__food .item_wrap:nth-child(4) .item', {duration: 0.3, rotate: 0}, 0)

    }
}

function toggleExpandable() {
    var listExpandable = $(".list_wrap__expandable");
    $("#close_expandable").hide();

    $("#open_expandable").click(function () {
        event.preventDefault();
        $("#open_expandable").hide();
        $("#close_expandable").show();
        listExpandable.slideDown({
            start: function () {
                $(this).css({
                    display: "flex"
                })
            },
            duration: 600
        });
        listExpandable.show();
    });
    $("#close_expandable").click(function () {
        event.preventDefault();
        $("#open_expandable").show();
        $("#close_expandable").hide();
        listExpandable.slideUp("slow");
    });
}

function moveExpandableDiv() {
    if (window.matchMedia('(min-width: 768px) and (max-width: 991px)').matches) {
        var firstItem = $('.list_wrap__expandable .list__item:first-child');
        firstItem.each(function () {
            $(this).parent().before($(this));
        });
    }
}

function wrappingString() {
    if (!RegExp.escape) {
        RegExp.escape = function (value) {
            return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
        };
    }

    var term = "up hotel";
    var regex = new RegExp('(' + RegExp.escape(term) + ')', 'ig');
    var item = $("p");
    $(item).each(function () {

        $(this).contents().each(function () {
            if (this.nodeType == Node.TEXT_NODE && regex.test(this.nodeValue)) {
                $(this).replaceWith(this.nodeValue.replace(regex, '<span class="highlight">UP <strong>HOTEL</strong></span>'))
            }
        })
    });
}

function up_hotel_print_itinerary(pi) {
    var html = $('#map_directions').html();
    var hiddenForm = $('<form/>', {
        style: 'display:none;',
        target: 'printwindow',
        method: 'post',
        action: 'https://staticaws.fbwebprogram.com/fbmap/print_itinerary.php'
    });
    hiddenForm.append($('<input/>', {type: 'hidden', name: 'html', value: html}));
    window.open('', 'printwindow', 'toolbar=no,width=1000,height=550,menubar=no,scrollbars=yes,resizable=yes');
    $('body').append(hiddenForm);
    hiddenForm.submit();
}

function up_hotel_routes() {
    // starting up map template-part
    if (($('#map_box').length > 0)) {

        var container_map = $('.container_map');
        // travelmode selection
        var button_itinerary_mode = $('.itinerary_mode');
        button_itinerary_mode.click(function (e) {
            e.stopPropagation();
            // this
            var anchor = $(this);
            // check
            if (anchor.hasClass('active')) return false;
            // reset
            $('.itinerary_mode.active').removeClass('active');
            // adding class
            anchor.addClass('active');
        });

        // routing
        $('#calculate').on('click', function () {
            calcRoute();
        });
    }
}

function initializeMap() {
    if ($('body').hasClass('page-template-template-location')) {

        up_hotel_InitMap('map_box', gmap_config);
        up_hotel_routes();

        $('#calc_route_mobile').click(function () {
            if ($('#routes').is(':visible')) {
                $('#routes, #map_directions').slideUp();
            } else {
                $('#routes').slideDown();
            }

        });
    }

}

function mrprenoClass() {
    const container = $('body.page-template-template-location .myreply_form .container-fluid .col-xs-12');
    container.removeClass('col-md-6');
    container.addClass('col-md-12');
}

function isotope_filters() {
    if ($('body').hasClass('blog')) {
        var itemSelector = '.post_list__single';

        if ($('.post-categories').length === 0) return false;

        //isotope to filter each type of post_xxxx

        var $container = $('.post-list__wrap .post-list__wrap__inner');
        $container.isotope({
            transitionDuration: '0.8s',
            resizable: false,
            layoutMode: 'fitRows'
        });

        //Ascending order
        var responsiveIsotope = [
            [480, 4],
            [720, 6]
        ];
        var itemsPerPageDefault = 6;
        var itemsPerPage = defineItemsPerPage();
        var currentNumberPages = 1;
        var currentPage = 1;
        var currentFilter = 'all-items';
        var filterAtribute = 'data-category';
        var pageAtribute = 'data-page';
        var pagerClass = 'main-pagination';
        var initPageNumber = 1;

        function changeFilter(selector) {
            $container.isotope({
                filter: selector
            });
        }

        function goToPage(n) {
            currentPage = n;
            var selector = itemSelector;
            // selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
            selector += (currentFilter != 'all-items') ? '[' + filterAtribute + '*="' + currentFilter + '"]' : '[' + pageAtribute + '="' + currentPage + '"]';
            //selector += '[' + pageAtribute + '="' + currentPage + '"]';
            //selector="filter_8";
            changeFilter(selector);
        }


        function defineItemsPerPage() {
            var pages = itemsPerPageDefault;
            for (var i = 0; i < responsiveIsotope.length; i++) {
                if ($(window).width() <= responsiveIsotope[i][0]) {
                    pages = responsiveIsotope[i][1];
                    break;
                }
            }
            return pages;
        }

        function setPagination() {
            var itemsLength = $container.children(itemSelector).length;
            var pages = Math.ceil(itemsLength / itemsPerPage);
            var SettingsPagesOnItems = function () {
                // var itemsLength = $container.children(itemSelector).length;
                // var pages = Math.ceil(itemsLength / itemsPerPage);
                var item = 1;
                var page = 1;
                var selector = itemSelector;

                selector += (currentFilter != 'all-items') ? '[' + filterAtribute + '="' + currentFilter + '"]' : '';
                $container.children(selector).each(function () {
                    if (item > itemsPerPage) {
                        page++;
                        item = 1;
                    }
                    $(this).attr(pageAtribute, page);
                    item++;
                });
                currentNumberPages = page;
            }();

            if (pages > 1) {
                var CreatePagers = function () {
                    var $isotopePager = ($('.' + pagerClass).length == 0) ? $('<div class="' + pagerClass + '"></div>') : $('.' + pagerClass);
                    $isotopePager.html('');
                    for (var i = 0; i < currentNumberPages; i++) {
                        $is_first = (i === 0) ? 'current' : '';
                        var $pager = $('<a href="javascript:void(0);" class="pager page-numbers ' + $is_first + '" ' + pageAtribute + '="' + (i + 1) + '"></a>');
                        $pager.html(i + 1);
                        $pager.click(function () {
                            $('.main-pagination a').removeClass('current');
                            var page = $(this).eq(0).attr(pageAtribute);
                            $(this).addClass('current');
                            goToPage(page);

                            setTimeout(function () {
                                var init_posts = 0;
                                if (is_mobile) {
                                    init_posts = parseInt($('#news').offset().top) - 100;
                                } else {
                                    init_posts = parseInt($('#news').offset().top) - 200;
                                }

                                $(window).scrollTop(init_posts, {duration: 0});

                            }, 100);
                        });
                        $pager.appendTo($isotopePager);
                    }
                    $container.after($isotopePager);
                }();
            }


        }

        setPagination();
        goToPage(1);


        // filter items on button click
        // $('.post-categories li').on('click', 'a', function () {
        //     var filterValue = $(this).attr('data-category');
        //
        //     // $container.isotope({
        //     //     filter: filterValue,
        //     // });
        //     //
        //     // $('.post-categories li a').removeClass('active');
        //     // $(this).toggleClass('active');
        //
        // });

        $('.post-categories li').on('click', 'a', function () {

            var filter = $(this).attr(filterAtribute);
            currentFilter = filter;

            $(this).siblings().removeClass('active');
            $(this).toggleClass('active');

            setPagination();
            goToPage(1);

        });
    }
}

function uphotel_getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);
    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";
    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    var widthWithScroll = inner.offsetWidth;
    // remove divs
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
}

function uphotel_refresh_size_queries() {
    var classes = [];
    var scrollbarwidth = uphotel_getScrollbarWidth();
    window_width = $(window).width() + scrollbarwidth;
    window_height = $(window).height();
    is_phone = (window_width < 768);
    is_mobile = (window_width < 992);
    is_small_desktop = (window_width <= 1024);
    is_tablet_portrait = (window_width >= 768 && window_width < 992);
    is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
    is_tablet = is_tablet_portrait || is_tablet_landscape;
    is_desktop = (window_width >= 992);
    is_desktop_large = (window_width >= 1200);

    if (is_phone) {
        classes.push('mq_phone');
    }
    if (is_mobile) {
        classes.push('mq_mobile');
    }
    if (is_tablet_portrait) {
        classes.push('mq_tablet_portrait');
    }
    if (is_tablet_landscape) {
        classes.push('mq_tablet_landscape');
    }
    if (is_tablet) {
        classes.push('mq_tablet');
    }
    if (is_desktop) {
        classes.push('mq_desktop');
    }
    if (is_desktop_large) {
        classes.push('mq_desktop_large');
    }


    $('html').removeClass('mq_phone');
    $('html').removeClass('mq_mobile');
    $('html').removeClass('mq_tablet_portrait');
    $('html').removeClass('mq_tablet_landscape');
    $('html').removeClass('mq_tablet');
    $('html').removeClass('mq_desktop');

    $('html').addClass(classes.join(' '));
}

function eqipmentHeight() {
    var eqipment = $('body.blog .post_list__single'),
        maxHeight = 0;

    eqipment.each(function (index, el) {
        var eqipmentHeight = parseInt($(this).height());
        eqipmentHeight > maxHeight ? maxHeight = eqipmentHeight : false;
    });

    eqipment.height(maxHeight);
}

function doMasonry(main_container, single_item) {
    if ($('#gallery_filters').length === 0) return false;
    var width_box;
    if ($('body').hasClass('page-template-template-gallery')) {
        width_box = $(main_container).width() / 3;
    } else {
        width_box = $(main_container).width() / 2;
    }
    $(main_container).isotope({
        itemSelector: single_item,
        masonry: {
            columnWidth: width_box,
            horizontalOrder: true,
        }
    });

    //filter items on select
    $('#gallery_filters').on('click', 'a', function () {
        var filterValue = $(this).attr('data-category');

        $(main_container).isotope({
            filter: filterValue,
        });

        $('#gallery_filters a').removeClass('active');
        $(this).toggleClass('active');
    });
}

function gallery_isotope_filters() {
    if ($('#gallery_filters').length === 0) return false;
    var container = $('.photo-gallery-container');
    container.isotope({
        transitionDuration: '0.8s',
    });

    // filter items on button click
    $('#gallery_filters').on('click', 'a', function () {
        var filterValue = $(this).attr('data-category');

        container.isotope({
            filter: filterValue,
        });

        $('#gallery_filters a').removeClass('active');
        $(this).toggleClass('active');
    });
}

function faq() {
    var sections = $('.section.faq_section');
    var groupSection = sections.find('.faqs').children();
    groupSection.each(function () {
        var group = $(this);
        var groupBtn = group.find('.faq_group_title');
        /*var section = $(this);
        var groups = section.find('.faq_group');*/
        groupBtn.click(function () {
            var mainBtn = $(this);
            var hiddencontent = mainBtn.parent().find('> .hidden_description');
            groupHeight = hiddencontent.find('> .inner_wrap').outerHeight(true);
            if (!$(this).hasClass('open')) {
                hiddencontent.css({
                    height: groupHeight
                });
                $(this).addClass('open');
            } else {
                hiddencontent.css({
                    height: 0
                });
                $(this).removeClass('open');

                groupBtn.parent().find('.faq_hidden_description').css({
                    height: 0
                });
                groupBtn.parent().find('.faq_title').removeClass('open');
            }
        });

        var groupChildrenFaq = group.find('.group_children_faq').children();

        groupChildrenFaq.each(function () {
            var singleFaq = $(this);
            var singleFaqBtn = singleFaq.find('.faq_single_item');
            var hiddenContent = singleFaq.closest('.faq').find('> .hidden_description .inner_wrap').outerHeight(true);

            singleFaqBtn.click(function () {
                if (!$(this).hasClass('opened')) {
                    $(this).addClass('opened');
                    $(this).parent().find('> .group_hidden_description').css({
                        'height': hiddenContent
                    });
                    $(this).parent().find('> .group_hidden_description').on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
                        if ($(this).parent().find('> .group_hidden_description').height() > 0) {
                            var groupFaqDescription = $(this).closest('.group_faq_description');
                            groupFaqDescription.css({
                                height: $(this).parent().parent().height()
                            })
                        }
                    });
                } else {
                    $(this).removeClass('opened');
                    $(this).parent().find('> .group_hidden_description').css({
                        'height': 0
                    });
                    $(this).parent().find('> .group_hidden_description').on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
                        var groupFaqDescription = $(this).closest('.group_faq_description');
                        groupFaqDescription.css({
                            height: $(this).parent().parent().height()
                        })
                    });
                }
            });
        });
    });
}

function adjustHeightAmenities() {
    if (($('.slideshow__box').length)) {
        var heightSlideshow = $('#slideshow').outerHeight();

        if (window.matchMedia('(min-width: 991px)').matches) {
            var heightBoxSlideshow = $('.slideshow__box').outerHeight() - 85;
            var height = heightSlideshow + heightBoxSlideshow;
            if ($('body').hasClass('home')) {
                height = heightSlideshow + heightBoxSlideshow
            }
            $('.slideshow__wrap').css(
                'height', height
            );
        }

        if (window.matchMedia('(min-width: 991px)').matches) {
            var heightText = $('.slideshow__box .description').outerHeight(true);
            $('.amenities__infobox').css(
                'margin-top', -heightText
            );
        }
    }
}

function open_close_calendar() {
    var btns = $('#book_now_mobile, #book_now_desktop, #book_now_offer');
    var calendar_wrapper = $('#dyncal_wrapper');
    var calendar_box = $('#dyncal_box');
    if (btns.length == 0 || calendar_wrapper.length == 0) return;
    var mClass = ('visible');

    btns.click(function () {
        if (!calendar_wrapper.hasClass(mClass)) {
            calendar_wrapper.addClass(mClass);
            $('html, body').css('overflow', 'hidden');

        }
    });
    $('.close_calendar').click(function () {
        if (calendar_wrapper.hasClass(mClass)) {
            calendar_wrapper.removeClass(mClass);
            $('html, body').css('overflow', '');
        }
    });
};

window.isEmpty = function (obj) {
    // null and undefined are "empty"
    if (obj == null) return true;
    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;
    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
};

function heightItemSocialMedia() {
    if (($('body').hasClass('home')) && window.matchMedia('(min-width: 768px)').matches) {
        $('.sbi_item').each(function () {
            $(this).css('height', $(this).outerWidth());

            if ($(this).data('index') === 0) {
                $('.wrap_1').css('top', $(this).outerWidth());
            }
            if ($(this).data('index') === 3) {
                $(this).css('bottom', $('.wrap_4').outerWidth());
            }
        });
    }

}

function magneticArea() {
    var mArea = document.querySelector('#magnetic-area');

// 1. Set the function and variables
    function parallaxIt(e, target, movement = 1) {
        var boundingRect = mArea.getBoundingClientRect();
        var relX = e.pageX - boundingRect.left;
        var relY = e.pageY - boundingRect.top;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        gsap.to(target, {
            x: (relX - boundingRect.width / 2) * movement,
            y: (relY - boundingRect.height / 2 - scrollTop) * movement,
            ease: "power1",
            duration: 0.6
        });
    }

// 2. Call the function
    function callParallax(e) {
        parallaxIt(e, '.magnetic-content');
    }


    mArea.addEventListener('mousemove', function (e) {
        callParallax(e);
    });

    mArea.addEventListener('mouseenter', function (e) {
        gsap.to('.round', {
            scale: 1.2,
            ease: "power3",
            duration: 0.6
        });
    });

    mArea.addEventListener('mouseleave', function (e) {
        gsap.to('.round', {
            scale: 1,
            x: 0,
            y: 0,
            ease: "power3",
            duration: 0.6
        });
    });
}

function positionRibbon() {
    if ($('._dedge-ribbon').length) {
        if ($(this).hasClass('hidden')) {
            $('header').css('margin-top', '0');
            $('#breadcrumb').css('margin-top', '0');
            $('#menu_sidebar_wrap').css('margin-top', '0');
            $('#dyncal_wrapper').css('margin-top', '0');
            $('#whatsapp_fixed').css('margin-top', '0');
        } else {
            $('header').css('margin-top', '32px');
            $('#breadcrumb').css('margin-top', '32px');
            $('#menu_sidebar_wrap').css('margin-top', '32px');
            $('#dyncal_wrapper').css('margin-top', '32px');
            $('#whatsapp_fixed').css('margin-top', '32px');
        }

        $('#_dedge-ribbon-close').click(() => {
            if ($('._dedge-ribbon').hasClass('hidden')) {
                $('header').css('margin-top', '0');
                $('#breadcrumb').css('margin-top', '0');
                $('#menu_sidebar_wrap').css('margin-top', '0');
                $('#dyncal_wrapper').css('margin-top', '0');
                $('#whatsapp_fixed').css('margin-top', '0');
            } else {
                $('header').css('margin-top', '32px');
                $('#breadcrumb').css('margin-top', '32px');
                $('#menu_sidebar_wrap').css('margin-top', '32px');
                $('#dyncal_wrapper').css('margin-top', '32px');
                $('#whatsapp_fixed').css('margin-top', '32px');
            }
        })
    }
}

function borderPostList() {
    function allBorder() {
        if (window.matchMedia('(min-width: 991px)').matches) {
            var element = $('.post-list__wrap__inner .post_list__single:nth-child(3n+2)');
            element.addClass('post_border');
        }
    }

    allBorder();

    function categoryBorder() {
        if (window.matchMedia('(min-width: 991px)').matches) {
            var allElement = $('.post-list__wrap__inner .post_list__single');
            allElement.removeClass('post_border');
            setTimeout(function () {
                var element = $('.post-list__wrap__inner .post_list__single:not([style*="display: none"]):nth-child(3n+2)');
                element.addClass('post_border');
            }, 1000);

        }
    }

    $('.post-categories li a').click(function () {
        setTimeout(function () {
            categoryBorder();
        }, 500);
    });
}

$(document).ready(function () {


    // Init LazyLoad
    window.lazyLoadInstance = new LazyLoad({
        threshold: 100,
    });
    openCloseSidebar();
    breadcrumbPosition();
    toggleExpandable();
    slideshow();
    minigallery();
    slideshowPreviewRooms();
    slideshowNews();
    slideshowOffers();
    slideshowPosts();
    animationMainContent();
    animationEatDrink();
    animationFoodPrev();
    wrappingString();
    initializeMap();
    setTimeout(mrprenoClass, 500);
    isotope_filters();
    uphotel_getScrollbarWidth();
    uphotel_refresh_size_queries();
    eqipmentHeight();
    faq();
    adjustHeightAmenities();
    open_close_calendar();
    heightItemSocialMedia();
    moveExpandableDiv();
    magneticArea();
    positionRibbon();
    //up_hotel_print_itinerary();
    //showDirections();
    //borderPostList();
    //gallery_isotope_filters();
    doMasonry('.photo-gallery-container', '.single-image-wrap');
    window.onscroll = function () {
        fixedHeader();
    };
    window.onresize = function (event) {
        adjustHeightAmenities();
        moveExpandableDiv();
    };
    if (is_phone) {
        var googleReviews = jQuery('.wp-gr.wpac');
        // var shittyInterval = setInterval(function () {
            if (googleReviews.length > 0) {
                googleReviews.css({'width':'143px'});
                // clearInterval(shittyInterval);
            } //else {
                // console.log('not yet');
            // }
        // }, 500);
    }

});